"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRuleMet = isRuleMet;
function isRuleMet(evt, rule) {
  if (!isEvtRelevantToRule(evt, rule)) return false;
  return rule[3](evt.value);
}
function isEvtRelevantToRule(evt, rule) {
  return evt.whoAmI === rule[0] && evt.addonInput === rule[1] || rule[0] === "default";
}